export interface RecommendedProduct {
  name: string;
  brand: string;
  description: string;
  image: string;
  url: string;
  purpose?: string;
  isPrimary?: boolean;
}

export const NO_FINDINGS_RECOMMENDED_PRODUCTS: RecommendedProduct[] = [
  {
    isPrimary: true,
    name: "Pronamel Daily Protection Toothpaste",
    brand: "Sensodyne",
    description: "Helps protect enamel daily",
    purpose: "Primary Recommendation",
    image:
      "assets/haleon/recommended-products/pronamel-daily-protection-toothpaste.avif",
    url:
      "https://www.sensodyne.com/en-gb/products/pronamel-daily-protection-toothpaste/",
  },
  {
    name: "Pronamel Daily Mouthwash",
    brand: "Sensodyne",
    description: "Supports enamel between brushing",
    purpose: "Enamel Support",
    image: "assets/haleon/recommended-products/pronamel-daily-mouthwash.avif",
    url: "https://www.sensodyne.com/en-gb/products/pronamel-daily-mouthwash/",
  },
  {
    name: "Pronamel Gentle Whitening Toothpaste",
    brand: "Sensodyne",
    description: "Gently whitens teeth",
    purpose: "Gentle Whitening",
    image:
      "assets/haleon/recommended-products/pronamel-gentle-whitening-toothpaste.avif",
    url:
      "https://www.sensodyne.com/en-gb/products/pronamel-gentle-whitening-toothpaste/",
  },
  {
    name: "Pronamel Extra Freshness Toothpaste",
    brand: "Sensodyne",
    description: "Provides long-lasting freshness",
    purpose: "Fresh Breath",
    image:
      "assets/haleon/recommended-products/pronamel-extra-freshness-toothpaste.avif",
    url:
      "https://www.sensodyne.com/en-gb/products/pronamel-extra-freshness-toothpaste/",
  },
];

export const HAS_FINDINGS_RECOMMENDED_PRODUCTS: RecommendedProduct[] = [
  {
    isPrimary: true,
    name: "Pronamel Clinical Enamel Strength",
    brand: "Sensodyne",
    description: "Strengthens weakened enamel",
    purpose: "Primary Recommendation",
    image: "assets/haleon/recommended-products/clinical-enamel-strength.png",
    url: "https://www.pronamel.us/products/pronamel-clinical-enamel-strength/",
  },
  {
    name: "Pronamel Intensive Enamel Repair Extra Fresh Mouthwash",
    brand: "Sensodyne",
    description: "Freshens while supporting enamel",
    purpose: "Repair Freshness",
    image:
      "assets/haleon/recommended-products/pronamel-intensive-enamel-repair-extra-fresh-mouthwash.avif",
    url:
      "https://www.pronamel.us/products/pronamel-intensive-enamel-repair-extra-fresh-mouthwash/",
  },
  {
    name: "Pronamel Intensive Enamel Repair Whitening Toothpaste",
    brand: "Sensodyne",
    description: "Repairs enamel while whitening",
    purpose: "Repair Whitening",
    image:
      "assets/haleon/recommended-products/pronamel-intensive-enamel-repair.avif",
    url:
      "https://www.sensodyne.com/en-gb/products/pronamel-intensive-enamel-repair/",
  },
  {
    name: "Pronamel Intensive Enamel Repair Extra Fresh Toothpaste",
    brand: "Sensodyne",
    description: "Repairs enamel, boosts freshness",
    purpose: "Repair Freshness",
    image:
      "assets/haleon/recommended-products/pronamel-intensive-enamel-repair-toothpaste.avif",
    url:
      "https://www.sensodyne.com/en-gb/products/pronamel-intensive-enamel-repair-toothpaste/",
  },
];
